<template>
  <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <PermissionRole ref="roleTree" :OnTreeSelected="OnTreeSelected"></PermissionRole>
      </div>
      <div class="zj-layout-right">
        <MonitorPermissionList ref="monitorList"></MonitorPermissionList>
      </div>
  </zj-layout-container>
</template>
<script>

import MonitorPermissionList from "./MonitorPermissionList";
import PermissionRole from "./PermissionRole";

export default {
  name: "MonitorPermissionManage",
  controller: "UI",
  action: "MonitorPermissionManage",
  components: {
    MonitorPermissionList,
    PermissionRole
  },
  data(){
    return{

    }
  },
  created:function(){
    
  },
  mounted: function() {
    
  },
  methods:{
    OnTreeSelected(data){
    // console.log(data.IndexCode);
     this.$refs.monitorList.refreshRoleDevice(data);
    }
  },
}

</script>